import * as React from 'react';
import classnames from 'classnames';

import { useSurvey } from '@src/hooks/useSurvey';
import { SurveyQuestionProps } from './SurveyQuestion';

export interface TypeSingleChoiceProps extends SurveyQuestionProps {}

/**
 * @name TypeSingleChoice
 * @description This component allows our user to select "1/#" option
 * from a list of options.
 */
export const TypeSingleChoice = (props: TypeSingleChoiceProps) => {
  const { question } = props;

  // Setup
  const { choices = [], name, properties = {} } = question;
  const { columns } = properties;

  // Hooks
  const { answers, setAnswer } = useSurvey();
  const value = answers[name] || undefined;
  const [selected, setSelected] = React.useState(value);

  // Life Cycle
  React.useEffect(() => {
    setSelected(value);

    return () => {
      setSelected(value);
    };
  }, [question.id]);

  return (
    <div
      className={classnames('grid gap-2', {
        'grid-cols-2 md:grid-cols-3': columns === 3,
        'md:grid-cols-2': columns === 2,
        'min-h-[64px]': columns === 3
      })}
    >
      {choices.map((option) => {
        const onClick = () => {
          const isActive = selected === option.key;
          const value = isActive ? undefined : option.key;

          setSelected(value);
          setAnswer(name, value);
        };

        return (
          <div
            className={classnames(
              'cursor-pointer p-4 text-left font-beatrice-light text-16 md:px-8 md:text-18',
              {
                'bg-forest text-white': selected === option.key,
                'bg-white text-gray-8': selected !== option.key
              }
            )}
            key={option.key}
            onClick={onClick}
            onKeyPress={onClick}
            tabIndex={0}
          >
            {option.value}
          </div>
        );
      })}
    </div>
  );
};
